import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { X, ChevronLeft, ChevronRight } from "lucide-react";
import { gallery, galleryCategories, img } from "../mock";
import Seo from "../components/Seo";

const Gallery = () => {
  const [filter, setFilter] = useState("All");
  const [lightbox, setLightbox] = useState(null);

  const items = filter === "All" ? gallery : gallery.filter((g) => g.cat === filter);

  useEffect(() => {
    const obs = new IntersectionObserver((es) => es.forEach((e) => e.isIntersecting && e.target.classList.add("in")), { threshold: 0.05 });
    document.querySelectorAll(".mh-reveal").forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, [filter]);

  useEffect(() => {
    const onKey = (e) => {
      if (lightbox === null) return;
      if (e.key === "Escape") setLightbox(null);
      if (e.key === "ArrowRight") setLightbox((i) => (i + 1) % items.length);
      if (e.key === "ArrowLeft") setLightbox((i) => (i - 1 + items.length) % items.length);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [lightbox, items.length]);

  return (
    <div>
      <Seo
        title="Photo Gallery"
        description="Browse our gallery of custom homes by Monarch Homes of Brevard - designer kitchens, spa baths, coastal exteriors, oceanfront living and screened lanais across the Space Coast."
        keywords="custom home gallery Brevard County, Florida custom home photos, Melbourne Beach home builder gallery"
        path="/gallery"
      />
      <section className="mh-page-hero" style={{ backgroundImage: `url(${img.kitchen1})` }}>
        <div className="mh-page-hero-inner">
          <div className="mh-crumb"><Link to="/">Home</Link> / Gallery</div>
          <h1>Photo Gallery</h1>
        </div>
      </section>

      <section className="mh-section">
        <div className="mh-container">
          <div className="mh-section-head mh-reveal">
            <div className="mh-eyebrow">Our Craftsmanship</div>
            <h2>A Look Inside A Monarch Home</h2>
            <p>From designer kitchens and spa-inspired baths to coastal exteriors and screened lanais - explore the quality and detail in every home we build.</p>
            <div className="mh-divider" />
          </div>

          <div className="mh-gal-filters">
            {galleryCategories.map((c) => (
              <button key={c} className={`mh-gal-filter ${filter === c ? "active" : ""}`} onClick={() => setFilter(c)}>{c}</button>
            ))}
          </div>

          <div className="mh-masonry">
            {items.map((g, i) => (
              <div key={g.src} className="mh-gal-item mh-reveal" onClick={() => setLightbox(i)}>
                <img src={g.src} alt={g.label} loading="lazy" />
                <div className="mh-gal-cap">
                  <span>{g.cat}</span>
                  <strong>{g.label}</strong>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {lightbox !== null && (
        <div className="mh-lightbox" onClick={() => setLightbox(null)}>
          <button className="mh-lightbox-close" onClick={() => setLightbox(null)} aria-label="Close"><X size={30} /></button>
          <button className="mh-lightbox-nav prev" onClick={(e) => { e.stopPropagation(); setLightbox((i) => (i - 1 + items.length) % items.length); }} aria-label="Previous"><ChevronLeft size={26} /></button>
          <img src={items[lightbox].src} alt={items[lightbox].label} onClick={(e) => e.stopPropagation()} />
          <button className="mh-lightbox-nav next" onClick={(e) => { e.stopPropagation(); setLightbox((i) => (i + 1) % items.length); }} aria-label="Next"><ChevronRight size={26} /></button>
        </div>
      )}
    </div>
  );
};

export default Gallery;
